<template>
  <div class="home-view internal">
    <section class="form">
      <div class="container">
        <h1 class="title-default">Fórum de afetação <span>Utilize este espaço para interagir com os demais proprietários do empreendimento.</span></h1>

        <form @submit.prevent="send">
          <h3>{{ $store.state.nome }} <span>{{ model.unidades }}</span><br>&nbsp;</h3>

          <fieldset>
            <textarea required placeholder="Nova mensagem" v-model="model.mensagem"></textarea>
          </fieldset>

          <fieldset class="submit alignright">
            <button type="submit" class="btn" :disabled="isSending">Enviar</button>
          </fieldset> <!-- /.submit -->
        </form> <!-- /form -->
      </div> <!-- /.container -->
    </section> <!-- /.form -->

    <transition name="fade" mode="out-in">
      <section class="list" v-if="loaded">
        <div class="container">
          <ul>
            <li v-for="item in items" v-if="!item.isOculta" :key="item.id">
              <div class="left">
                <h6>{{ item.cliente }}</h6>
                <h6 class="black">{{ item.unidades }}</h6>
                <p><em>em {{ new Date(item.data) | moment('DD/MM/YYYY [às] HH:mm:ss') }}</em></p>
              </div> <!-- /.left -->

              <div class="right">
                <p>{{ item.mensagem }}</p>
              </div>
            </li> <!-- /li -->
          </ul> <!-- /ul -->
        </div>
      </section> <!-- /.list -->
    </transition>
  </div>
</template>

<script>
import PagesService from '@/services/Pages'

export default {
  name: 'forum',

  data () {
    const data = {
      loaded: false,
      isSending: false,
      items: [],
      model: {
        id: 0,
        cliente: '',
        cpf: '',
        unidades: '',
        mensagem: '',
        empreendimentoId: 0,
        isOculta: false
      }
    }

    return data
  }, // data()

  beforeMount () {
    this.loadList()
  }, // beforeMount()

  mounted () {
    this.model.cpf = this.$store.state.documento
    this.model.cliente = this.$store.state.nome
    this.model.empreendimentoId = this.$store.state.contratoAtual.empreendimentoIdWeb

    let { bloco, unidade } = this.$store.state.contratoAtual
    this.model.unidades = `${bloco} - ${unidade}`
  }, // mounted()

  methods: {
    async loadList () {
      let { empreendimentoIdWeb } = this.$store.state.contratoAtual

      try {
        let xhr = await PagesService.getForum(empreendimentoIdWeb)

        this.items = xhr
        this.loaded = true
      } catch (e) {
        console.error('Falha ao recuperar documentos', e)
      }
    }, // loadList()

    async send () {
      if (this.isSending) return

      this.isSending = true

      try {
        let xhr = await PagesService.postForum(this.model)

        this.loaded = false
        this.model.mensagem = ''

        await this.loadList()

        this.isSending = false
        this.loaded = true
      } catch (e) {
        console.error('Erro ao salvar post no forum', e)
      }
    } // send()
  }, // methods

  computed: {
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  section.form
    form
      padding: 25px 33px

      h3
        span
          font-weight: 700
          color: #292929

      textarea
        background-color: map-get($colors, bg_body)
        border-radius: 0
        font-style: normal
        font-size: 15px
        font-family: 'Arial', sans-serif

      fieldset
        &.submit
          display: flex
          justify-content: flex-end

          .btn
            width: 189px
            height: 46px
            font-weight: 700
            font-size: 22px

  @media (max-width: 1024px)

    section.form
      padding: 0

      h1
        padding-top: 20px

      form
        padding: 20px 15px

        h3
          text-align: left
          font-size: 16px
          line-height: 1.2
          padding: 0 10px

          span
            font-weight: 700
            color: #292929

        textarea
          background-color: map-get($colors, bg_body)
          border-radius: 0
          font-style: normal
          font-size: 15px
          font-family: 'Arial', sans-serif

        fieldset
          &.submit
            display: flex
            justify-content: flex-end

            .btn
              width: 100%
              height: 44px
              font-size: 20px

</style>
